var _ = require('underscore')
  , urlUtils = require('@173js/url')
  , EMTPY = '0'

exports.getNavClass = function(params) {
  var urlParams = this.urlParams
    , isCurrent = _.every(
        _.map(params, function(param, paramKey) {
          param = '' + param

          return param === urlParams[paramKey] ||
            param === EMTPY && !urlParams[paramKey]
        })
      )

  return isCurrent ? 'current' : ''
}

exports.getFilterUrl = function(params) {
  return urlUtils.addParam(
    this.currentListUrl
  , _.extend(_.clone(this.urlParams), params)
  )
}
